// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"22197868","328":"8dda0ef5","474":"53cc7704","617":"272849b8","627":"e9bde66e","780":"335d7cd2","798":"c4a52227","834":"16fdcfbc","878":"ac694491","896":"6bdeda3e","931":"b6cdc38e","966":"6277bb61"}[chunkId] + ".chunk.js";
};